export const GLOBALIZATION_CURRENCY_FEATURE_KEY = 'common.globalization.currency';
